export default "__VITE_ASSET__CIXwrmju__"